module.exports = __webpack_public_path__ + "static/media/style.0c1eb4e5.less";